+function ($) {
	'use strict';

	// Validate forms
	if ($('.form-validate').length>0) $('.form-validate').validate({
		rules: {
			password1: {
				required: true,
				minlength: 8
			},
			password2: {
				equalTo: '#password1'
			}
		},
		errorPlacement: function(error, element) {
			error.insertBefore(element.parent());
		},
		highlight: function(element) {
			$(element).closest('.input-group').addClass('error');
		},
		unhighlight: function(element) {
			$(element).closest('.input-group').removeClass('error');
		}
	});
}(jQuery);